module.exports = __webpack_public_path__ + "img/kv-bg.24b26811.png";